import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

import initPostsListingTop from "./elements/posts-listing-top.mjs";
import initSearchForm from "./elements/search-form.mjs"

initPostsListingTop();

initSearchForm();